import {copyEditorJson} from '../../protocol/native-envelope';
import type {CompanyLibrarySource} from '../../protocol/library-source';
import type {EditorState} from '../../vendor/src/features/remotion-editor/editor/state/types';
import type {EditorStarterAsset} from '../../vendor/src/features/remotion-editor/editor/assets/assets';
import {hasPendingTimelineEdit} from './edit-ownership';

export const libraryAssetKindMatches=(kind:CompanyLibrarySource['kind'],type:EditorStarterAsset['type'])=>
  kind===type||(kind==='image'&&(type==='gif'||type==='webp'));

export function retainCompanyLibraryAsset(state:EditorState,asset:EditorStarterAsset,source:CompanyLibrarySource){
  if(!source.id||asset.remoteUrl!==source.url||!libraryAssetKindMatches(source.kind,asset.type))
    throw new Error('자료함 원본과 읽은 파일이 일치하지 않습니다.');
  const duplicate=Object.values(state.undoableState.assets).find(value=>{
    if(!('wakaLibrarySource' in value)||!value.wakaLibrarySource||typeof value.wakaLibrarySource!=='object')return false;
    return 'id' in value.wakaLibrarySource&&'signature' in value.wakaLibrarySource&&value.wakaLibrarySource.id===source.id
      &&value.wakaLibrarySource.signature===source.signature&&value.remoteUrl===source.url;
  });
  if(duplicate)return {state,already:true};
  if(hasPendingTimelineEdit(state)||state.undoableState.assets[asset.id])throw new Error('현재 편집을 마친 뒤 원본을 다시 추가해 주세요.');
  const linked={...asset,wakaLibrarySource:copyEditorJson(source)};
  return {already:false,state:{...state,undoableState:{...state.undoableState,assets:{...state.undoableState.assets,[asset.id]:linked}},
    assetStatus:{...state.assetStatus,[asset.id]:{type:'uploaded' as const}}}};
}
